//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {MessageBox} from "element-ui";
import codeImg from '@/static/picture/code.png';

let defaultCheck = ['tmimg' ,'trademark' ,'code'];
export default {
  props: ["num", "maxNum", "tipTitle", "pageHeader"],
  data() {
    return {
      dialogVisible: false,
      steep: 1,
      // 新增选项
      bType: [],
      checkList: [],
      loading: false
    };
  },
  /*computed: {
    isUserMember(){
      const userInfo = this.$store.state.user;
      let isUse = false
      if(userInfo){
        // 4: AI尊享版  3：AI精英版 2：AI标准版  39:AI精英版体验 37：AI标准版体验
        isUse = userInfo.uc_vip_level === 3 || userInfo.uc_vip_level === 2 || userInfo.uc_vip_level === 4 || userInfo.uc_vip_level === 39 || userInfo.uc_vip_level === 37
      }
      return isUse
    }
  },*/
  mounted() {
    /*console.log( 555,this.key)
    this.$axios.post('/api/Export/getExportHeader', {key: this.key}).then(res => {
      this.bType = res.data.data
    })*/
    // this.getHeader()
  },
  methods: {
    getHeader(){
      this.loading = true;
      this.checkList = [];
      this.$axios.post('/api/Export/getExportHeader', {key: this.pageHeader}).then(res => {
        this.bType = res.data.data;
        this.loading = false;
        let checkListModel = this.bType.filter(item => (item.selected === 1)).map(item => item.field);
        this.checkList = checkListModel;
      })
    },
    showModel() {
      /* 试用版提示 */
      if(this.$store.state.user.uc_vip_level === 21){
        MessageBox.alert(`<p>该功能仅供付费会员使用，请使用微信扫码联系客服升级会员畅享更多专属权益！</p><div class="codeImgTip"><img src="${codeImg}"/></div>`, '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '了解更多',
          center: true,
          type: 'warning',
          customClass: 'commonTip'
        }).then(()=> {
          this.$router.push({
            path:"/user/VersionIntroduction",
          })
        });
        return
      }




      if (this.num) {
        this.steep = 1;
        if(this.pageHeader) this.getHeader();
        this.dialogVisible = true;
      } else {
        this.$message("无数据");
      }
    },
    goExportManage() {
      window.open("/user/exportManage", "_blank");
    },
    subInfo(type) {
      if (type == 1) {
        if(this.pageHeader) this.$emit("listExport", this.checkList);
        else this.$emit("listExport");
        this.steep = 2;
      } else {
        this.dialogVisible = false;
        this.goExportManage();
      }
    },
    // 重置
    resetClick(){
      this.$axios.post('/api/Export/reSetExportHeader', {key: this.pageHeader}).then(res => {
        this.bType = res.data.data;
        let checkListModel = this.bType.filter(item => (item.selected === 1)).map(item => item.field);
        this.checkList = checkListModel;
      })

    }
  }
};
